import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state() {
    return {
      isLoading: false,
      isButtonLoading: false,
      errors: [],
      errorFields: {},
      isErrorModalOpened: false,
      isBiometricModalOpened: false,
      isTermsModalOpened: false,
      modalBackToRoute: null,
      hasNotification: localStorage.getItem('hasNotification') || null,
      isWebView: false,
      modalTitle: '',
      isQrScanClosed: true,
      qrPointData: null,
      backRouteName: null,
      isLinkageView: false,
      notClickOutside: false,
      qrRouteData: {},
      isPayCameraOpened: false,
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true,
};
